export const GITCHA_PRO_PATH = "/gitcha-pro";
export const GITCHA_PRO_KEEP_PATH = "/gitcha-pro?keep=1";
